import React from 'react';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import AuthContext from "./auth/Context";
import isObject from "lodash/isObject";
import ManagedModal from './ManagedModal';

class Alert extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={
      title:null,
      color:"black",
      formOpen:false
    }
    this.onhashchange = this.onhashchange.bind(this);
  }
  onhashchange(){
    if(this.current_hash!=window.location.hash){
      this.setState({formOpen:false});
    }
  }
  async componentDidMount(){
    window.addEventListener("hashchange",this.onhashchange);
  }
  componentWillUnmount(){
   window.removeEventListener("hashchange",this.onhashchange)
  }
  close(){
    this.setState({formOpen:false});
  }
  show(title,callback,color="black",options={}){
    if(!title) return;

    this.current_hash = window.location.hash;
    if(!React.isValidElement(title)){
      if(isObject(title)){
        title = title.message || title.error || JSON.stringify(title);
      }
      title = <div style={{color,textAlign:title.toString().indexOf("<")<0?'center':undefined,padding:10}} dangerouslySetInnerHTML={{__html:title.toString()}}></div>
    }
    this.setState({title,color,callback,maxWidth:options.maxWidth,fullWidth:options.fullWidth,fullScreen:options.fullScreen,formOpen:true});
  }
  render(){
    const {getLabel} = this.context.apis;
    return (
      <ManagedModal
        type="dialog"
        fullScreen={this.state.fullScreen||false}
        fullWidth = {this.state.fullWidth||false}
        maxWidth={this.state.maxWidth||"md"}
        open={this.state.formOpen}
        onClose={()=>{
          this.setState({formOpen:false});
          if(this.state.callback) this.state.callback(false);
        }}
      >
        <DialogContent>
          <form noValidate style={{display:"flex",flexDirection:"column",height:"100%"}}>
            <div style={{flex:1,overflow:"auto"}}>
              {this.state.title}
            </div>
            <div style={{padding:10,textAlign:'center'}}>
              {!this.state.callback &&
                <Button variant="contained" onClick={()=>this.close()}>
                  {getLabel("Đóng")}
               </Button>
              }
              {this.state.callback &&
                <>
                 {React.isValidElement(this.state.callback)?
                  <div onClick={()=>this.close()}>{this.state.callback}</div>
                 :
                  <>
                    <Button
                      variant="contained"
                      onClick={()=>{
                        this.close();
                        this.state.callback(true);
                      }}>
                      {getLabel("Có")}
                    </Button>
                    <Button
                      variant="contained"
                      onClick={()=>{
                        this.close();
                        this.state.callback(false);
                      }}
                      style={{marginLeft:20}}>
                      {getLabel("Không")}
                    </Button>
                  </>
                  }
                </>
              }
            </div>
          </form>
        </DialogContent>
      </ManagedModal>
    );
  }
}
Alert.contextType = AuthContext;
export default  Alert;